export const AGENCIES_TO_HIDE_ENDORSEMENT = new Set(['dartmouth-college']);
